import type { Component, ViewMode } from '@wix/thunderbolt-becky-types'
import { pointers } from '@wix/thunderbolt-becky-types'
import { getUniqueId } from '@wix/thunderbolt-commons'
import _ from 'lodash'

const PROPERTY_TYPES = pointers.components.PROPERTY_TYPES

const DATA_QUERIES_TO_INFLATE = [
	PROPERTY_TYPES.BEHAVIOR_QUERY,
	PROPERTY_TYPES.BREAKPOINTS_QUERY,
	PROPERTY_TYPES.PROPERTY_QUERY,
	PROPERTY_TYPES.CONNECTION_QUERY,
	PROPERTY_TYPES.DESIGN_QUERY,
	PROPERTY_TYPES.DATA_QUERY,
	PROPERTY_TYPES.LAYOUT_QUERY,
	PROPERTY_TYPES.MOBILE_HINTS_QUERY,
	PROPERTY_TYPES.STYLE_ID,
	PROPERTY_TYPES.TRANSFORMATION_QUERY,
	PROPERTY_TYPES.TRANSITION_QUERY,
	PROPERTY_TYPES.PRESETS_QUERY, // TODO: under ByRefV2 experiment
	PROPERTY_TYPES.SLOTS_QUERY,
	PROPERTY_TYPES.VARIABLES_QUERY,
]

const isMobile = (viewMode: ViewMode) => viewMode === 'mobile'

const getUniqueDataQuery = (id: string, suffix: string, withMobileSuffix?: boolean) =>
	`${id}-${suffix}${withMobileSuffix ? '-mobile' : ''}`

const inflateQueries = (inflatedCompId: string, viewMode: ViewMode) =>
	_(DATA_QUERIES_TO_INFLATE)
		.mapKeys((x) => x)
		.mapValues((dataQueryName) => {
			const isMobileProperty = isMobile(viewMode) && dataQueryName === PROPERTY_TYPES.PROPERTY_QUERY
			return getUniqueDataQuery(inflatedCompId, dataQueryName, isMobileProperty)
		})
		.value()

export const inflateCompStructure = ({
	component,
	parentRefCompId,
	pageId,
	isRootComp,
	viewMode,
}: {
	component: Component
	parentRefCompId: string
	pageId: string
	isRootComp: boolean
	viewMode: ViewMode
}): Component => {
	const templateCompId = component.id
	const inflatedCompId = getUniqueId(parentRefCompId, templateCompId)

	return {
		...component,
		...inflateQueries(inflatedCompId, viewMode),
		templateId: templateCompId,
		id: inflatedCompId,
		metaData: {
			...component.metaData,
			pageId,
		},
		parent: isRootComp ? parentRefCompId : getUniqueId(parentRefCompId, component.parent as string),
		components: component.components
			? component.components.map((childCompId) => getUniqueId(parentRefCompId, childCompId))
			: undefined,
	}
}
